<template>
  <KeepAlive>
    <Modal
      classs
      c-class="gf_shortcut-modal"
      h-class="gf_shortcut-modal__header"
      m-class="gf_shortcut-modal__body"
      f-class=""
      :break-line="true"
      @cancel="cancel">
      <template #header>
        <div class="gf_shortcut-modal__header-group">
          <h2 class="heading-20-medium">Keyboard Shortcuts</h2>
          <div class="gf_shortcut-modal__header-group--action" @click.prevent="cancel">
            <span class="icon-close" />
          </div>
        </div>
      </template>
      <template #default>
        <div class="gf_shortcut-modal__body-group">
          <div class="gf_shortcut-modal__body-group__box gf_shortcut-modal__body-group__box--one">
            <div class="gf_shortcut-modal__body-group__box__list">
              <div class="gf_shortcut-modal__body-group__box__item">
                <div class="gf_shortcut-modal__body-group__box__item--label"></div>
                <div class="gf_shortcut-modal__body-group__box__item__mode">
                  <div class="gf_shortcut-modal__body-group__box__item__mode--window paragraph-12-semibold-150">
                    Windows
                  </div>
                  <div class="gf_shortcut-modal__body-group__box__item__mode--mac paragraph-12-semibold-150">MacOS</div>
                </div>
              </div>

              <div v-for="(item, key) in shortcutLeft" :key="key" class="gf_shortcut-modal__body-group__box__item">
                <div class="gf_shortcut-modal__body-group__box__item--label paragraph-12-semibold-150">
                  {{ item.label }}
                </div>
                <div class="gf_shortcut-modal__body-group__box__item__mode">
                  <div class="gf_shortcut-modal__body-group__box__item__mode--window paragraph-12-semibold-150">
                    <div
                      v-for="(win, keyW) in item.windows"
                      :key="keyW"
                      class="gf_shortcut-modal__body-group__box__item__mode__key paragraph-12-medium">
                      <span v-if="win.icon" :class="win.icon" />
                      <template v-else> {{ win.code }} </template>
                    </div>
                  </div>
                  <div class="gf_shortcut-modal__body-group__box__item__mode--mac paragraph-12-semibold-150">
                    <div
                      v-for="(mac, keyM) in item.macos"
                      :key="keyM"
                      class="gf_shortcut-modal__body-group__box__item__mode__key paragraph-12-medium">
                      <span v-if="mac.icon" :class="mac.icon" />
                      <template v-else> {{ mac.code }} </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="gf_shortcut-modal__body-group__box gf_shortcut-modal__body-group__box--two">
            <div class="gf_shortcut-modal__body-group__box__list">
              <div class="gf_shortcut-modal__body-group__box__item">
                <div class="gf_shortcut-modal__body-group__box__item--label"></div>
                <div class="gf_shortcut-modal__body-group__box__item__mode">
                  <div class="gf_shortcut-modal__body-group__box__item__mode--window paragraph-12-semibold-150">
                    Windows
                  </div>
                  <div class="gf_shortcut-modal__body-group__box__item__mode--mac paragraph-12-semibold-150">MacOS</div>
                </div>
              </div>

              <div v-for="(item, key) in shortcutRight" :key="key" class="gf_shortcut-modal__body-group__box__item">
                <div class="gf_shortcut-modal__body-group__box__item--label paragraph-12-semibold-150">
                  {{ item.label }}
                </div>
                <div class="gf_shortcut-modal__body-group__box__item__mode">
                  <div class="gf_shortcut-modal__body-group__box__item__mode--window paragraph-12-semibold-150">
                    <div
                      v-for="(win, keyW) in item.windows"
                      :key="keyW"
                      class="gf_shortcut-modal__body-group__box__item__mode__key paragraph-12-medium">
                      <span v-if="win.icon" :class="win.icon" />
                      <template v-else> {{ win.code }} </template>
                    </div>
                  </div>
                  <div class="gf_shortcut-modal__body-group__box__item__mode--mac paragraph-12-semibold-150">
                    <div
                      v-for="(mac, keyM) in item.macos"
                      :key="keyM"
                      class="gf_shortcut-modal__body-group__box__item__mode__key paragraph-12-medium">
                      <span v-if="mac.icon" :class="mac.icon" />
                      <template v-else> {{ mac.code }} </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template #footer>
        <div class="gf_shortcut-modal__footer-group">
          <Toggler v-model="shortcutStatus" @input="changeStatusShortcut" />
          <label
            class="gf_shortcut-modal__footer-group--label paragraph-16-regular"
            @click="shortcutStatus = !shortcutStatus">
            <template v-if="shortcutStatus">Keyboard Shortcuts is enable</template>
            <template v-else>Keyboard Shortcuts is disable</template>
          </label>
        </div>
      </template>
    </Modal>
  </KeepAlive>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapMutations, mapActions, mapState } from 'vuex';
import { mutations as AppMutations } from '@/store/app/types';

export default defineComponent({
  name: 'ShortcutModal',
  components: {},
  props: {
    settingUrl: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    shortcutStatus: false,
    shortcutLeft: [
      {
        label: 'Undo',
        windows: [
          {
            code: 'Ctrl',
            icon: '',
          },
          {
            code: 'Z',
            icon: '',
          },
        ],
        macos: [
          {
            code: '',
            icon: 'icon-macos',
          },
          {
            code: 'Z',
            icon: '',
          },
        ],
      },
      {
        label: 'Redo',
        windows: [
          {
            code: 'Ctrl',
            icon: '',
          },
          {
            code: 'Shift',
            icon: '',
          },
          {
            code: 'Z',
            icon: '',
          },
        ],
        macos: [
          {
            code: '',
            icon: 'icon-macos',
          },
          {
            code: 'Shift',
            icon: '',
          },
          {
            code: 'Z',
            icon: '',
          },
        ],
      },
      {
        label: 'Copy Style',
        windows: [
          {
            code: 'Ctrl',
            icon: '',
          },
          {
            code: 'Alt',
            icon: '',
          },
          {
            code: 'C',
            icon: '',
          },
        ],
        macos: [
          {
            code: '',
            icon: 'icon-macos',
          },
          {
            code: 'Alt',
            icon: '',
          },
          {
            code: 'C',
            icon: '',
          },
        ],
      },
      {
        label: 'Paste Style',
        windows: [
          {
            code: 'Ctrl',
            icon: '',
          },
          {
            code: 'Alt',
            icon: '',
          },
          {
            code: 'V',
            icon: '',
          },
        ],
        macos: [
          {
            code: '',
            icon: 'icon-macos',
          },
          {
            code: 'Alt',
            icon: '',
          },
          {
            code: 'V',
            icon: '',
          },
        ],
      },
      {
        label: 'Duplicate',
        windows: [
          {
            code: 'Ctrl',
            icon: '',
          },
          {
            code: 'D',
            icon: '',
          },
        ],
        macos: [
          {
            code: '',
            icon: 'icon-macos',
          },
          {
            code: 'D',
            icon: '',
          },
        ],
      },
      {
        label: 'Delete',
        windows: [
          {
            code: 'Delete',
            icon: '',
          },
        ],
        macos: [
          {
            code: 'Delete',
            icon: '',
          },
        ],
      },
      {
        label: 'Quit / Back',
        windows: [
          {
            code: 'Esc',
            icon: '',
          },
        ],
        macos: [
          {
            code: 'Esc',
            icon: '',
          },
        ],
      },
    ],
    shortcutRight: [
      {
        label: 'Save',
        windows: [
          {
            code: 'Ctrl',
            icon: '',
          },
          {
            code: 'S',
            icon: '',
          },
        ],
        macos: [
          {
            code: '',
            icon: 'icon-macos',
          },
          {
            code: 'S',
            icon: '',
          },
        ],
      },
      {
        label: 'Save & Publish',
        windows: [
          {
            code: 'Ctrl',
            icon: '',
          },
          {
            code: 'Shift',
            icon: '',
          },
          {
            code: 'S',
            icon: '',
          },
        ],
        macos: [
          {
            code: '',
            icon: 'icon-macos',
          },
          {
            code: 'Shift',
            icon: '',
          },
          {
            code: 'S',
            icon: '',
          },
        ],
      },
      {
        label: 'Open Library',
        windows: [
          {
            code: 'Ctrl',
            icon: '',
          },
          {
            code: 'L',
            icon: '',
          },
        ],
        macos: [
          {
            code: '',
            icon: 'icon-macos',
          },
          {
            code: 'L',
            icon: '',
          },
        ],
      },
      {
        label: 'Bold Text',
        windows: [
          {
            code: 'Ctrl',
            icon: '',
          },
          {
            code: 'B',
            icon: '',
          },
        ],
        macos: [
          {
            code: '',
            icon: 'icon-macos',
          },
          {
            code: 'B',
            icon: '',
          },
        ],
      },
      {
        label: 'Italic Text',
        windows: [
          {
            code: 'Ctrl',
            icon: '',
          },
          {
            code: 'I',
            icon: '',
          },
        ],
        macos: [
          {
            code: '',
            icon: 'icon-macos',
          },
          {
            code: 'I',
            icon: '',
          },
        ],
      },
      {
        label: 'Underline Text',
        windows: [
          {
            code: 'Ctrl',
            icon: '',
          },
          {
            code: 'U',
            icon: '',
          },
        ],
        macos: [
          {
            code: '',
            icon: 'icon-macos',
          },
          {
            code: 'U',
            icon: '',
          },
        ],
      },
      {
        label: 'Keyboard Shortcuts',
        windows: [
          {
            code: 'Ctrl',
            icon: '',
          },
          {
            code: '/',
            icon: '',
          },
        ],
        macos: [
          {
            code: '',
            icon: 'icon-macos',
          },
          {
            code: '/',
            icon: '',
          },
        ],
      },
    ],
  }),
  computed: {
    ...mapState('app', {
      shopInfo: 'shopInfo',
    }),
    isOnShortcut() {
      return this.shopInfo?.storeInfo?.shortcut;
    },
  },
  watch: {
    isOnShortcut: {
      immediate: true,
      handler(newV, oldV) {
        if (newV === oldV) {
          return;
        }
        this.shortcutStatus = newV;
      },
    },
  },
  async created() {
    this.shortcutStatus = this.shopInfo?.storeInfo?.shortcut;
  },
  methods: {
    ...mapActions('editor', {
      updateShortcut: 'updateShortcut',
    }),
    ...mapMutations('app', {
      commitShop: AppMutations.MUTATE_SHOP_INFO,
    }),
    cancel() {
      this.$emit('cancel');
    },
    async changeStatusShortcut() {
      return this.updateShortcut(this.shortcutStatus).then(() => {
        const shopInfo = this.shopInfo;
        shopInfo.storeInfo.shortcut = this.shortcutStatus;
        this.commitShop(shopInfo);
      });
    },
  },
});
</script>

<style lang="scss">
@import '@/app/editor/scss/variables';
@import '@/core/themes/vendor/color';
@import '@/core/themes/vendor/variables';
@import '@/core/themes/vendor/mixins';

$screen-md: 848px;
$label: 125px;

.gf_shortcut-modal {
  width: $screen-md;
  border-radius: 0 !important;
  background: map-get($hybrid-shade-light, '100') !important;
  &__header {
    padding: 24px 32px;
    border-bottom: 1px solid map-get($text-dark-mode, 'high-contrast');
    &-group {
      @include flex-align-center;
      justify-content: space-between;
      &--action {
        @include flex-align-justify-center;
        width: 24px;
        height: 24px;
        cursor: pointer;
        border-radius: 3px;
        background: map-get($hybrid-shade-light, '100');
        &:hover {
          background: map-get($text-dark-mode, 'high-contrast');
        }
        .icon-close {
          height: 16px;
          font-size: 16px;
        }
      }
    }
  }
  &__body {
    border-bottom: 1px solid map-get($text-dark-mode, 'high-contrast');
    &-group {
      @include flex-align-center;
      padding: 24px 32px;
      &__box {
        flex: 0 0 50%;
        max-width: 50%;
        &__item {
          @include flex-align-center;
          padding: 24px 0;
          border-bottom: 1px solid map-get($hybrid-shade-light, '300');
          &:first-child {
            border: 0;
            padding-bottom: 0;
            padding-top: 0;
          }
          &:last-child {
            border: 0;
            padding-bottom: 0;
          }
          &--label {
            width: $label;
            text-align: left;
            display: inline-block;
            color: map-get($text-light-mode, 'low-contrast');
          }
          &__mode {
            flex-basis: 0;
            flex-grow: 1;
            max-width: 100%;
            width: 100%;
            @include flex-align-center;
            &--window {
              font-family: 'Inter';
              flex: 0 0 50%;
              max-width: 50%;
              color: map-get($text-light-mode, 'disabled');
              padding-right: 8px;
              @include flex-align-center;
            }
            &--mac {
              font-family: 'Inter';
              flex: 0 0 50%;
              max-width: 50%;
              color: map-get($text-light-mode, 'disabled');
              padding-left: 8px;
              @include flex-align-center;
            }
            &__key {
              @include flex-align-justify-center;
              padding: 3px;
              width: max-content;
              min-width: 22px;
              height: 22px;
              border: 1px solid map-get($hybrid-shade-light, '500');
              color: map-get($text-light-mode, 'high-contrast');
              box-sizing: border-box;
              border-radius: 2px;
              margin-right: 13px;
              font-family: 'Inter';
              text-align: center;
              position: relative;
              cursor: default;
              &::before {
                content: '+';
                font-family: 'Inter';
                font-style: normal;
                font-weight: 600;
                font-size: 12px;
                position: absolute;
                right: -11px;
                top: 50%;
                transform: translateY(-50%);
              }
              &:last-child {
                margin-right: 0;
                &::before {
                  display: none;
                }
              }
              .icon-macos {
                font-size: 12px;
                line-height: unset;
                position: relative;
                &::before {
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  transform: translate(-50%, -50%);
                  font-size: 12px;
                }
              }
            }
          }
        }
        &--one {
          padding-right: 22px;
        }
        &--two {
          padding-left: 22px;
        }
      }
    }
  }
  &__footer {
    &-group {
      @include flex-align-center;
      padding: 22px 32px;
      &--label {
        margin-left: 10px;
        padding-bottom: 0;
        color: map-get($text-light-mode, 'low-contrast');
        font-family: 'Inter';
        cursor: pointer;
      }
    }
  }
}
</style>
